// components/SingleResponsePreview.jsx
import React from 'react';
import './styles/SingleResponsePreview.css'; // ← import the CSS

const renderRowBadges = (row) => {
  // your existing badges logic or just return null for now
  return null;
};

const SingleResponsePreview = ({ question }) => {
  const { Qtitle = '', instructions = '', rows = [] } = question || {};

  if (!rows?.length) {
    return (
      <div className="survey-single-response" style={{ color: '#6b7280' }}>
        No options available for this question
      </div>
    );
  }

  return (
    <div className="survey-single-response">
      {/* Title */}
      <div
        className="survey-question-title"
        dangerouslySetInnerHTML={{ __html: Qtitle || 'Question text missing' }}
      />

      {/* Instructions */}
      {instructions && (
        <div
          className="survey-instructions"
          dangerouslySetInnerHTML={{ __html: instructions }}
        />
      )}

      {/* Options */}
      <div className="survey-options-list">
        {rows.map((row) => (
          <label key={row.index || row.id || row.text} className="survey-option-label">
            <div className="survey-option-content">
              <input
                type="radio"
                readOnly
                className="survey-radio"
              />
              <span
                className="survey-option-text"
                dangerouslySetInnerHTML={{ __html: row.text || '—' }}
              />
            </div>

            {renderRowBadges(row)}

            {row.other && (
              <div className="survey-other-container">
                <input
                  type="text"
                  placeholder="Please specify..."
                  readOnly
                  className="survey-other-input"
                />
              </div>
            )}
          </label>
        ))}
      </div>

      <div className="survey-hint">
        Select one option
      </div>
    </div>
  );
};

export default SingleResponsePreview;